import { render, staticRenderFns } from "./VariationOptionModal.vue?vue&type=template&id=206a12be&"
import script from "./VariationOptionModal.vue?vue&type=script&lang=js&"
export * from "./VariationOptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports